<template>
  <div
    id="mhr-hero"
    class="mhr-hero-full d-flex align-center justify-center red mhr-lightblue mhr-white--text"
  >
    <v-container class="d-flex flex-column align-center flex-lg-row-reverse justify-lg-space-between text-center text-lg-start">
      <div class="mhr-text-404 mhr-font d-flex align-end justify-end mb-8 mb-lg-0">
        404
      </div>
      <div class="d-flex flex-column align-center align-lg-start align-self-stretch justify-space-between">
        <div class="mhr-text-h1 mhr-font mb-8 mb-lg-0 px-8 px-lg-0">We were unable to find the page you are looking for.</div>
        <v-btn
          tile color="mhr-blue" elevation="0"
          class="mhr-section-btn-2 mhr-white--text px-9 mt-16 mt-lg-0"
          :to="{ name: 'Home' }"
        >
          Back to Homepage
        </v-btn>
      </div>
    </v-container>
  </div>
</template>

<script>
  // Extensions
  import View from '@/views/View'

  export default {
    name: 'ErrorNotFound',
    extends: View
  }
</script>
